$(function() {
	$('body').on('click', '.discard-feedback', function(){
		$('.feedback-message-holder').fadeOut('fast');
		var that = $(this); 
		$.ajax({
			url: that.attr('href'),
		})
		return false;
	});

	$('body').on('change', 'input[name="suggestions"]', function() {
		var textarea_holder = $(this).parents('.form-row-block').find('.textarea-place');
		if( $(this).val() == 'Yep' ) {
			textarea_holder.show();
			textarea_holder.find('textarea').focus();
		}else{
			textarea_holder.hide();
		}
	});

	window.feedback_form_sent = function (response) {
		$('#popup-container').html('<span class="popup-loading">' + response + '</span>');
		$('.feedback-message-holder').slideUp();
		
		setTimeout(function () {
			$('#popup').hide();
		}, 4000);
	}
});
